<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<lowgile-table
					#datatable_5
					[serverDataStore]="Orders.Db"
					[trackBy]="trackByAutomatic"
					[entity]="Orders.CustomerRequestItem"
					[columns]="_DataTableBlock_columns_5(screen)"
					[showSettings]="false"
					[userDefinedConfiguration]="undefined"
					[usePaging]="true"
					[pageSize]="20"
					[pageSizeOptions]="[10, 20, 50]"
					[useGlobalFilter]="false"
					[debouncingDelay]="250"
					[stickyHeader]="true"
					[additionalFindOptions]="_DataTableBlock_additionalFindOptions_5({ app, screen, $pathSegments, $disabled })"
					[additionalHeaderRows]="[]"
					[additionalFooterRows]="[]"
					[allClasses]="$Modules"
					[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
					[surroundingScope]="$scope"
					#$table_5="lowgileTable"
				>
					<ng-container [lowgile-column]="'request.id'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Request ID' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Request ID'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<a
										routerLink="/CustomerRequestView"
										[queryParams]="{ requestId: item.requestId }"
										routerLinkActive="is-current-link"
										target="_blank"
									>
										<span
											[innerHtml]="item.requestId | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</a>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('request.id') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container [lowgile-column]="'request.date'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Request date' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Request date'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_14({ app, screen, $pathSegments, $disabled, item, itemIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('request.date') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container [lowgile-column]="'material'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Material' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Material'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<div
										class="layout-block vertical"
										[style.align-items]="'inherit'"
										[style.gap]="'0.25em'"
									>
										<ng-container
											*ngFor="let material of item.materials; let materialIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="material; as: 'material'; let $scope"
											>
												<ng-container
													*lowgileScope="materialIndex; as: 'materialIndex'; let $scope"
												>
													<span
														style="white-space: nowrap"
														[style.font-weight]="screen.referenceMaterials.includes(material.name) ? 'bold' : ''"
														[innerHtml]="material.name | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</ng-container>
									</div>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('material') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container [lowgile-column]="'processingMethod'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Processing method' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Processing method'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<span
										[style.font-weight]="screen.referenceProcessingMethods.includes(item.processingMethod.id) ? 'bold' : ''"
										[innerHtml]="item.processingMethod.label | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('processingMethod') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container [lowgile-column]="'attachments'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Attachments' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Attachments'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<span
										[innerHtml]="_DataTableColumnBlock_cellText_7({ app, screen, $pathSegments, $disabled, item, itemIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('attachments') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>

					<ng-container [lowgile-column]="'Offered quantities'">
						<th mat-header-cell *matHeaderCellDef>
							<span
								[innerHtml]="'Quantities / prices' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span>
						</th>
						<td
							mat-cell
							*matCellDef="let item; let itemIndex = index"
							[attr.data-label]="'Quantities / prices'"
						>
							<ng-container *lowgileScope="item; as: 'item'; let $scope">
								<ng-container
									*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
								>
									<div
										class="layout-block vertical"
										[style.align-items]="'inherit'"
										[style.gap]="'0.25em'"
									>
										<ng-container *ngIf="item.customerOfferItem; else else21"
											><span
												[innerHtml]="`[${item.request.customerOffer.currency.label}]` | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
											<ng-container
												*ngFor="let quantity of item.customerOfferItem.quantities ?? []; let quantityIndex = index; trackBy: trackByAutomatic"
											>
												<ng-container
													*lowgileScope="quantity; as: 'quantity'; let $scope"
												>
													<ng-container
														*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
													>
														<span
															style="white-space: nowrap"
															[innerHtml]="`${quantity.quantity}: ${Sys.Text.formatAsCurrency(quantity.unitPrice)} [M: ${Sys.Text.formatAsCurrency(quantity.margin)} / ${Sys.Text.formatAsDecimalNumber(100 * quantity.margin / (quantity.unitPrice - quantity.margin), 0)}%]` | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</ng-container>
												</ng-container> </ng-container
										></ng-container>
										<ng-template #else21>
											<span
												[innerHtml]="item.quantities.join(', ') | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</ng-template>
									</div>
								</ng-container>
							</ng-container>
						</td>
					</ng-container>
					<ng-container [lowgile-column]="('Offered quantities') + '$$filter'">
						<th mat-header-cell *matHeaderCellDef></th>
					</ng-container>
				</lowgile-table>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
